export default "__VITE_ASSET__BmXwfyld__"